(function ($) {
    $.fn.formFieldIsset = function () {

        return this.each(function () {

            const $form = $(this),
                $fields = $form.find('input, textarea, select').not(':button, :submit, :reset, [type="hidden"], .fieldIsset');

            function isset(el,type) {
                let isset = false;
                if($.inArray(type,["checkbox","radio"]) > -1) {
                    if (el.prop('checked') === true || el.prop('selected') === true) {
                        isset = true;
                    }
                } else {
                    if (el.val() !== "") {
                        isset = true;
                    }
                }

                if (isset) {
                    el.attr('data-isset', true);
                } else {
                    el.attr('data-isset', false);
                }

            }

            $fields.each(function () {
                const el = $(this),
                    type = el.attr('type');
                el.addClass('fieldIsset');
                isset(el, type);
            });
            $fields.on('input', function () {
                $(this).trigger('change');
            });
            $fields.on('change', function () {
                const el = $(this),
                    type = el.attr('type'),
                    form_el = el.closest('.form-element');

                isset(el, type);

                //Clear form errors
                if(form_el.hasClass('has-error')){
                    form_el.removeClass('has-error');
                    form_el.find('.error-msg').hide();
                }

            });

        });

    };
})(jQuery);
